export const faqTableColumns = [
  {
    prop: 'short_name',
    title: 'common.fields.short_name',
    width: '50%',
    sortingEnabled: true,
  },
  {
    prop: 'human_order',
    title: 'common.fields.human_order',
    width: '20%',
    sortingEnabled: true,
  },
  {
    prop: 'is_active',
    title: 'common.fields.is_active',
    width: '18%',
    sortingEnabled: true,
  },
  {
    prop: 'actions',
    title: 'common.fields.actions',
    width: '12%',
    sortingEnabled: false,
  },
];
